module.exports = __webpack_public_path__ + "img/message-question-checkmark.637ac8e2.svg";